"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInitialValues = void 0;
var _react = require("react");
var _context = require("../../../context");
var _constants = require("../../../constants");
var _getMinInitialPayment = require("../utils/getMinInitialPayment");
const useInitialValues = () => {
  const {
    startPrice,
    withEscrow,
    programs,
    region
  } = (0, _context.useAppContext)();
  return (0, _react.useMemo)(() => {
    if (!programs.length) {
      return {
        initialPrice: startPrice,
        initialPayment: startPrice * 0.2,
        initialPeriod: _constants.DEFAULT_PAYMENT_PERIOD,
        withEscrow
      };
    }
    // Находим программу с максимальным первым взносом
    const maxInitialPayment = programs.reduce((maxInitialPayment, _ref) => {
      let {
        creditLimitMillions,
        minInitialPaymentPercent
      } = _ref;
      const initialPayment = getInitialPayment(startPrice, creditLimitMillions[region], minInitialPaymentPercent);
      return !maxInitialPayment || maxInitialPayment <= initialPayment ? initialPayment : maxInitialPayment;
    }, 0);
    return {
      initialPrice: startPrice,
      initialPayment: maxInitialPayment,
      initialPeriod: _constants.DEFAULT_PAYMENT_PERIOD,
      withEscrow
    };
  }, [programs, region, startPrice, withEscrow]);
};
exports.useInitialValues = useInitialValues;
function getInitialPayment(startPrice, creditLimitMillions, minInitialPaymentPercent) {
  const minPaymentForProgram = getMinPaymentForProgram(startPrice, creditLimitMillions);
  const minInitialPayment = (0, _getMinInitialPayment.getMinInitialPayment)(startPrice, minInitialPaymentPercent);
  return Math.max(minInitialPayment, minPaymentForProgram);
}

/**
 * Вычисляет сумму, которую нужно внести в качестве первоначального взноса, чтобы объект можно было купить по программе
 *
 * Например, по семейной ипотеке лимит 9 млн, а стоимость объекта 15 млн.
 * Чтобы купить объект по этой программе, клиент должен внести первоначальный взнос в размере 6 млн.
 *
 * @param startPrice - стоимость объекта
 * @param programCreditLimitMillions - лимит по программе в миллионах
 */
function getMinPaymentForProgram(startPrice, programCreditLimitMillions) {
  return startPrice - programCreditLimitMillions * 1000000;
}